// @flow

import React, {Fragment} from 'react';
import StarRating from '@homeaway/react-star-rating';
import gql from 'graphql-tag';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import './Rating.less';

import type {Node} from 'react';

export const fragments = {
    Listing: gql`
        fragment RatingListing on Listing {
            averageRating
            reviewCount
        }
    `
};
export type ListingShape = {
    averageRating: number,
    reviewCount: number,
    starSize: string
};
export type Props = {
    listing: ListingShape,
    isDualPrice: boolean
};

const Rating = ({
    listing: {averageRating, reviewCount, starSize},
    isDualPrice
}: Props) => {
    if (!reviewCount) {
        return (
            <span className="sr-only">
                <FormattedMessage id="noReviews" defaultMessage="no reviews" />
            </span>
        );
    }

    let starRatingProps = {
        rating: averageRating,
        size: starSize
    };

    if (isDualPrice) {
        starRatingProps = {
            ...starRatingProps,
            useSingleStar: true,
            label: (
                <span className="Rating__starRating--label">
                    {averageRating.toFixed(1)}
                </span>
            )
        };
    }

    const ratingCountClass = classNames({
        'Rating__starRating--ratingcount': isDualPrice
    });

    return (
        <Fragment>
            <div className={'Rating__starRating'} aria-hidden="true">
                <StarRating {...starRatingProps} />
            </div>
            <span className={ratingCountClass} aria-hidden="true">
                {`(${reviewCount})`}
            </span>
            <span className="sr-only">
                <FormattedMessage
                    id="ratingScreenReaderLabel"
                    defaultMessage="Guest Rating: {rating} out of possible 5 stars. Number of Reviews: {reviewCount}"
                    values={{
                        rating: averageRating.toFixed(2),
                        reviewCount
                    }}
                >
                    {(txt: Node): Node => txt}
                </FormattedMessage>
            </span>
        </Fragment>
    );
};

Rating.defaultProps = {
    isDualPrice: false
};

export default Rating;
